import VerifyEmailError from "../components/VerifyEmailError/VerifyEmailError";

const VerifyEmailErrorContainer = () => {
  return <VerifyEmailError />;
};

export default VerifyEmailErrorContainer;
